import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { useRouter } from 'vue-router';
import { onMounted, ref, watch } from 'vue';
import { setCurrentPageTitle } from '@/core/helpers/breadcrumb';
import { DinhMucCoDinhService } from '@/core/services/DinhMucCoDinh.service';
import { IDinhMucCoDinhNewResponseBase } from '@/core/interfaces/ApiResponses';
import { swalErrNotification } from '@/core/helpers/utils';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import { useLoading } from '@/core/hooks/use-loading';
import { usePagination } from '@/core/hooks/use-pagination';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import DinhMucCoDinhTable from '@/components/dinh-muc-co-dinh/dinh-muc-co-dinh-table/DinhMucCoDinhTable.vue';
import PageRowLayout from '@/layout/_shared/PageRowLayout.vue';
import PerPageSelection from '@/components/shared/per-page-selection/PerPageSelection.vue';
import Pagination from '@/components/shared/pagination/Pagination.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const items = ref<IDinhMucCoDinhNewResponseBase[]>([]);

const { startLoading, endLoading } = useLoading();

const { ButtonsType } = useButtonCustom();

const { push } = useRouter();

const { currentPage, perPage, perPageArr, totalItems } = usePagination();

const fetchData = async () => {
  try {
    await startLoading();

    const { data: { data: { data, total } } } = await DinhMucCoDinhService.getList({
      current_page: currentPage.value,
      per_page: perPage.value,
    });

    items.value = data;

    totalItems.value = total;

    await endLoading();
  } catch (error) {
    await endLoading();

    await swalErrNotification(error, 'Có lỗi xảy ra');
  }
}

onMounted(async () => {
  setCurrentPageTitle('Định mức cố định');

  await fetchData();
});

watch(
  [currentPage, perPage],
  () => {
    fetchData();
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageRowLayout, null, {
    "page-row-header": _withCtx(() => [
      _createTextVNode(" Danh sách ")
    ]),
    "page-row-action-button": _withCtx(() => [
      _createVNode(ButtonCustom, {
        "button-type": _unref(ButtonsType).ADD,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(push)({ name: 'tao-moi-dinh-muc-co-dinh' })))
      }, null, 8, ["button-type"])
    ]),
    "page-row-content": _withCtx(() => [
      _createVNode(PerPageSelection, {
        "per-page": _unref(perPage),
        "per-page-arr": _unref(perPageArr),
        onChange: _cache[1] || (_cache[1] = (value) => perPage.value = value)
      }, null, 8, ["per-page", "per-page-arr"]),
      _createVNode(DinhMucCoDinhTable, {
        "cur-page": _unref(currentPage),
        items: items.value,
        "per-page": _unref(perPage)
      }, null, 8, ["cur-page", "items", "per-page"]),
      (items.value.length > 0)
        ? (_openBlock(), _createBlock(Pagination, {
            key: 0,
            page: _unref(currentPage),
            "page-size": _unref(perPage),
            total: _unref(totalItems),
            onChangePage: _cache[2] || (_cache[2] = (value) => currentPage.value = value)
          }, null, 8, ["page", "page-size", "total"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})